export class Step10 {
  constructor() {}
  intitule = 'stepper.form.commun.mapa.step10';
  getspan9 = 'bloc_commun.mapa.getspan9';
  getspan10 = 'bloc_commun.mapa.getspan10';
  getdatefindiffusion = 'bloc_commun.mapa.getdatefindiffusion';
  getobjetavis = 'bloc_commun.mapa.getobjetavis';
  getnomorganisme = 'bloc_commun.mapa.getnomorganisme';
  getspan11 = 'bloc_commun.mapa.getspan11';
  getspan12 = 'bloc_commun.mapa.getspan12';
  getcriteressociaux = 'bloc_commun.mapa.getcriteressociaux';
  getspan13 = 'bloc_commun.mapa.getspan13';
  getcriteresenvironnementaux = 'bloc_commun.mapa.getcriteresenvironnementaux';
  getoui = 'bloc_commun.mapa.getoui';
  getnon = 'bloc_commun.mapa.getnon';
  getmotclef = 'bloc_commun.mapa.getmotclef';

}
